import { ScreenTypes } from '../utils/ScreensList';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SiteExperienceConfiguration } from '../common-types/ScreensConfigurations.type';

interface DisplayedScreen {
  displayError: boolean;
  displayedScreen: ScreenTypes;
  isLoading: boolean;
}

const initialState = {
  displayError: false,
  displayedScreen: ScreenTypes.HOME,
  isLoading: true,
};

export const displayedScreenSlice = createSlice({
  initialState,
  name: 'GameExperience',
  reducers: {
    transitionFromLoadingToFirstScreen (
      state: DisplayedScreen,
      { payload }: PayloadAction<{ siteConfiguration: SiteExperienceConfiguration, hasOnlyOneGame: boolean, firstGameHasBeenPlayed: boolean }>
    ) {
      let screenToDisplay = ScreenTypes.HOME;
      if (payload.firstGameHasBeenPlayed) {
        screenToDisplay = ScreenTypes.ALREADY_PLAYED;
      } else if (payload.hasOnlyOneGame && payload.siteConfiguration.singleGame.activated) {
        screenToDisplay = ScreenTypes.SINGLEGAME;
      } else if (!payload.hasOnlyOneGame && payload.siteConfiguration.multiGame.activated) {
        screenToDisplay = ScreenTypes.MULTIGAME;
      } else if (payload.siteConfiguration.collect.activated) {
        screenToDisplay = ScreenTypes.COLLECT;
      }
      return {
        ...state,
        displayedScreen: screenToDisplay,
        isLoading: false,
      };
    },
    transitionAfterWelcomeScreen (state: DisplayedScreen, { payload }: PayloadAction<{ collectScreenIsActivated: boolean }>) {
      return {
        ...state,
        displayedScreen: payload.collectScreenIsActivated
          ? ScreenTypes.COLLECT
          : ScreenTypes.HOME,
      };
    },
    transitionAfterCollectScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.HOME,
      };
    },
    transitionFromGameHomeToGameScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.GAME,
      };
    },
    transitionFromGameToGameResult (state: DisplayedScreen, { payload }: PayloadAction<{ hasWon: boolean }>) {
      return {
        ...state,
        displayedScreen: payload.hasWon
          ? ScreenTypes.WON
          : ScreenTypes.LOST,
      };
    },
    transitionFromGameResultToNextGame (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.HOME,
      };
    },
    displayErrorScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayError: true,
        displayedScreen: ScreenTypes.ERROR,
        isLoading: false,
      };
    },
    displayAlreadyPlayedScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.ALREADY_PLAYED,
        isLoading: false,
      };
    },
  },
});

const { actions, reducer } = displayedScreenSlice;

export const {
  transitionFromLoadingToFirstScreen,
  transitionAfterWelcomeScreen,
  transitionAfterCollectScreen,
  transitionFromGameHomeToGameScreen,
  transitionFromGameToGameResult,
  transitionFromGameResultToNextGame,
  displayErrorScreen,
  displayAlreadyPlayedScreen,
} = actions;
export default reducer;
